import type { GuestAnalyticsEvent } from "@shared/types/guest";
import { sendEvents } from "./api";

/**
 * Tiny client-side analytics buffer. Aggregate, anonymous - no device
 * fingerprint, no per-visitor id (see docs §6.4). Events are batched and flushed
 * on an interval and whenever the page is hidden/unloaded.
 */
const queue: GuestAnalyticsEvent[] = [];
let started = false;
// De-dupe section_view spam within a session (one per section is enough signal).
const seenSections = new Set<string>();

export function track(type: string, target?: string): void {
  if (type === "section_view" && target) {
    if (seenSections.has(target)) return;
    seenSections.add(target);
  }
  queue.push({ type, target, at: Date.now() });
  if (queue.length >= 20) flush();
}

export function flush(): void {
  if (!queue.length) return;
  const batch = queue.splice(0, queue.length);
  sendEvents(batch);
}

/** Begin periodic + lifecycle-driven flushing. Idempotent. */
export function startAnalytics(): void {
  if (started) return;
  started = true;
  setInterval(flush, 10_000);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
}
